import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { editorProjectServices } from "../../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const InformationConsole = ({
  ids,
  isFullScreenMode,
  openRightTab,
  isFullScreen,
  setIsFullScreen,
}) => {
  const [info, setInfo] = useState("");
  const [infoLoader, setInfoLoader] = useState(false);
  const { studyId } = useParams();
  const getProjectInformation = async (projectId, uniqueId) => {
    setInfoLoader(true);
    let data = await editorProjectServices.getProjectInformation(
      studyId,
      projectId,
      uniqueId
    );
    setInfo(data?.data || "");
    setInfoLoader(false);
  };
  useEffect(() => {
    if (ids?.projectId && ids?.uniqueId) {
      getProjectInformation(ids?.projectId, ids?.uniqueId);
    }
  }, [ids?.projectId, ids?.uniqueId, openRightTab]);

  return (
    <div className="overflow-hidden w-100">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-1">
          <i className="fa-solid fa-info"></i>
          <h6 className="m-0">Header Information</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title={`${isFullScreen ? "Minimize" : "Maximize"} Console`}
            className={`fa-solid ${isFullScreen ? "fa-minimize" : "fa-maximize"
              } CP`}
            onClick={() => setIsFullScreen(!isFullScreen)}
          />
        </div>
      </div>
      <div
        className="p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 70px)"
            : "calc(100vh - 216px)",
          overflowY: "auto",
        }}
      >
        {infoLoader ? (
          <PageLoader />
        ) : (
          <Table
            className="m-0 border-start border-end custom-table"
            bordered
            hover
            striped
          >
            <thead className="position-sticky top-0">
              <tr>
                <th>Attribute</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Sponsor Name</td>
                <td>{info?.sponsor}</td>
              </tr>
              <tr>
                <td>Project Id</td>
                <td>{info?.projectId}</td>
              </tr>
              <tr>
                <td>Study Id</td>
                <td>{info?.studyId}</td>
              </tr>
              <tr>
                <td>Programmer Name</td>
                <td>{info?.programmerName}</td>
              </tr>
              <tr>
                <td>Project Name</td>
                <td>{info?.name}</td>
              </tr>
              <tr>
                <td>Program Name</td>
                <td>
                  {info?.fileName}.{info?.extension}
                </td>
              </tr>
              <tr>
                <td>Current Program Version</td>
                <td>v{info?.version}</td>
              </tr>
              <tr>
                <td>Program Location</td>
                <td title={`/${ids?.path}.${info?.extension}`}>
                  /{ids?.path}.{info?.extension}
                </td>
              </tr>
              <tr>
                <td>Software Version</td>
                <td>v2.0.0</td>
              </tr>
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default InformationConsole;
